// Hook de sécurité — respecte prefers-reduced-motion.
// Retourne true si l'utilisateur a demandé à réduire les animations.
// À utiliser dans les composants pour désactiver ou raccourcir les animations.
//
// Exemple :
//   const reduced = useMotionSafe();
//   <motion.div {...(reduced ? {} : slide)}> ... </motion.div>

import { useReducedMotion } from "framer-motion";

export function useMotionSafe() {
  const reduced = useReducedMotion();
  return reduced === true;
}
